import { defineComponent as n, h as t } from "vue";
const u = n({
  props: {
    onFocus: Function,
    onBlur: Function
  },
  setup(o) {
    return () => t("div", {
      style: "width: 0; height: 0",
      tabindex: 0,
      onFocus: o.onFocus,
      onBlur: o.onBlur
    });
  }
});
export {
  u as default
};
